import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation TransferByEmail($chatId: ID!, $targetId: ID) {
    transferByEmail(chatId: $chatId, targetId: $targetId) {
      id
      status
    }
  }
`);
